import React from "react";

const PageLoader = () => {
  return (
    <div className="pageLoaderContainer">
      <div className="loader" />
    </div>
  );
};

export default PageLoader;
